/**
 * Read content from a file stored on the user's computer
 * @param {File|Blob} file
 *
 * @returns {Promise<string>}
 */
export function fileReader(file) {
  return new Promise((resolve) => {
    const r = new FileReader()
    r.readAsDataURL(file)

    r.onabort = () => console.log('File reading was aborted.')
    r.onerror = () => console.log('File reading has failed.')
    r.onload = () => resolve(r.result)
  })
}

export function convertBytes(bytes) {
  const unidades = ['B', 'KB', 'MB', 'GB']
  let valor = bytes

  for (let i = 0; i < unidades.length; i++) {
    if (valor < 1024 || i === unidades.length - 1) {
      return valor.toFixed(1) + ' ' + unidades[i]
    }
    valor /= 1024
  }
}
export const verifyFileVirus = ({ data, dispatch, userId, updateFiles, sent, isOutbound=false }) => {
  if(data.error){
    if(isOutbound){
      return {
        existVirus: true,
        attachmentsVirus: data.attachments
      }
    }else{
      dispatch(updateFiles(userId, data.attachments, true))
      dispatch(sent(userId))
      return { existVirus: true }
    }
  }
  return { existVirus: false }
}

export const formatBytes = (bytes, decimals = 2) => {
  if (typeof bytes !== 'number') return '0 B'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals

  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes/Math.pow(k, i))).toFixed(dm)} ${sizes[i]}`
}